import React from 'react';
import { ReactComponent as IconIA } from 'assets/images/icone-ia.svg';
import useIsFidelizeAutofill from 'hooks/useIsFidelizeAutofill';
import { IaBadgeWrapper, NoticeBox } from './styles';

export const IaBadge: React.FC = () => {
  const isFidelizeAutofill = useIsFidelizeAutofill();

  return (
    <IaBadgeWrapper
      className="databalloon float-right"
      aria-label={
        isFidelizeAutofill
          ? 'Dados preenchidos automaticamente'
          : 'IA: Dados retirados do Edital/Anexo/Contrato'
      }
      data-balloon-pos="up"
    >
      {isFidelizeAutofill ? (
        <i className="material-icons ia-badge" role="img">
          info
        </i>
      ) : (
        <IconIA className="ia-badge" role="img" />
      )}
    </IaBadgeWrapper>
  );
};

export const AutofillValidationHint: React.FC = () => {
  const isFidelizeAutofill = useIsFidelizeAutofill();

  return (
    <div className="mb-3">
      {isFidelizeAutofill
        ? 'As informações abaixo foram preenchidas automaticamente, valide cada item individualmente para prosseguir.'
        : 'As informações abaixo foram preenchidas previamente com auxilio da IA, valide a informação cada item individualmente para prosseguir.'}
    </div>
  );
};

const AiAutofillNotice: React.FC = () => {
  const isFidelizeAutofill = useIsFidelizeAutofill();

  return (
    <NoticeBox className="mb-4">
      {isFidelizeAutofill ? (
        <i className="material-icons ia-badge" aria-hidden="true">
          info
        </i>
      ) : (
        <IconIA className="ia-badge" role="img" aria-hidden="true" />
      )}
      <span>
        {isFidelizeAutofill
          ? 'Algumas informações foram preenchidas automaticamente, confira atenciosamente antes de prosseguir.'
          : 'Algumas informações foram preenchidas com o uso do nosso agente de IA, confira atenciosamente antes de prosseguir.'}
      </span>
    </NoticeBox>
  );
};

export default AiAutofillNotice;
